import React, { useState } from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

const SuccessComponent = ({ successMessage, showSuccess, setShowSuccess }) => {
  
  if (!showSuccess) return null;
  return (
    <MessageBar
      messageBarType={MessageBarType.success}
      isMultiline={false}
      dismissButtonAriaLabel="Close"
      onDismiss={() => setShowSuccess(false)}
      className="my-1"
    >
      {successMessage}
    </MessageBar>
  );
};

export default SuccessComponent;
